import React from "react";
import { Building, Email } from "../Assets/Icons";

const ContactUs = () => {
  return (
    <section id="contact-us" className="py-24 px-6 lg:px-20 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-['IBM_Plex_Mono'] text-[#F07023] text-xs tracking-[0.3em] uppercase">
            Get in Touch
          </span>
          <h2 className="text-[clamp(1.5rem,2.5vw,2.75rem)] font-[700] text-gray-900 mt-4 leading-tight">
            Contact Us
          </h2>
          <div className="w-12 h-px bg-[#F07023] mx-auto mt-6" />
        </div>

        <div className="max-w-lg mx-auto">
          <div className="border-l-4 border-[#F07023] pl-6 pr-4 py-6">
            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <span className="mt-0.5 flex-shrink-0">{Building}</span>
                <span className="text-gray-500 leading-relaxed">
                  #198 CMH Road, 2nd Floor, Desk No.159
                  <br />
                  Indira Nagar, Bengaluru, Karnataka 560038
                </span>
              </li>
              <li className="flex items-center gap-4">
                <span className="flex-shrink-0">{Email}</span>
                <a
                  href="mailto:rangr@orangecells.com"
                  className="text-gray-500 hover:text-[#F07023] transition-colors duration-200"
                >
                  rangr@orangecells.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
